/**
 * Jewelry gift wrap add-on.
 *
 * Renders alongside the buy_buttons block on jewelry product pages (via the
 * `jewelry_gift_wrap` block in sections/main-product.liquid). When checked,
 * adds one unit of the flat-fee "Gift Wrapping" product to the cart -- once
 * per cart, not once per item -- since wrapping is done as a single box
 * covering everything the customer wants wrapped together.
 *
 * Hooks into the theme's existing `product-ajax:added` event (dispatched by
 * the `product-form` custom element in theme.js after a successful add to
 * cart) rather than touching the add-to-cart flow itself, so this stays
 * fully decoupled from the core cart logic. After adding the wrap item, it
 * dispatches the theme's own `cart:refresh` event, the same mechanism the
 * theme itself uses to resync the cart drawer, so the drawer reflects the
 * wrap charge correctly.
 */
(function () {
  function alreadyInCart(cart, variantId) {
    return cart.items.some(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function addGiftWrap(variantId) {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (alreadyInCart(cart, variantId)) return null;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        }).then(function (response) {
          return response.json();
        });
      })
      .then(function (result) {
        if (result === null) return;

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true },
          })
        );
      })
      .catch(function (error) {
        console.error('Gift wrap add-on error:', error);
      });
  }

  document.addEventListener('product-ajax:added', function () {
    document.querySelectorAll('[data-jewelry-gift-wrap]').forEach(function (wrapper) {
      var checkbox = wrapper.querySelector('input[type="checkbox"]');
      var variantId = wrapper.getAttribute('data-wrap-variant-id');

      if (checkbox && checkbox.checked && variantId) {
        addGiftWrap(variantId);
      }
    });
  });
})();
